import { Row } from "antd";
import { Filters } from "./Filters";
import { useMemo, useState } from "react";
import { useFetchData } from "../hooks/useFetchData";
import { List } from "./List";
import { ISelectedConversation } from "../../../types/SelectedConversation";
import { EmptyList } from "../../Chat/components/EmptyList";
import { useReadConversation } from "../hooks/useReadConversation";
import { usePollConversations } from "../hooks/usePollConversations";

type ListContainerProps = {
  conversation: ISelectedConversation | null;
  setConversation: React.Dispatch<
    React.SetStateAction<ISelectedConversation | null>
  >;
};

export const ListContainer = ({
  conversation,
  setConversation,
}: ListContainerProps) => {
  const [unread, setUnread] = useState<boolean>(false);

  const { data, isLoading, setData } = useFetchData();

  usePollConversations(setData);

  const { readConversation } = useReadConversation(setData, setConversation);

  const emptyList = useMemo(
    () => ({
      title: "No messages yet",
      subTitle: "You can start conversation from account details.",
    }),
    []
  );

  return (
    <Row className="d-block list pt-8 overflow-y-auto">
      {!isLoading && data.length === 0 ? (
        <Row className="w-100 justify-center">
          <EmptyList data={emptyList} />
        </Row>
      ) : (
        <>
          <Filters isLoading={isLoading} setUnread={setUnread} />
          <List
            conversation={conversation}
            data={data}
            isLoading={isLoading}
            unread={unread}
            readConversation={readConversation}
          />
        </>
      )}
    </Row>
  );
};
